import { Box, Button, Stack, Typography } from '@dtx-company/design-system/src'
import { FC, useMemo } from 'react'
import { hexToRgb } from '@app/page/src/utils/theme'
import NextImage from 'next/image'
import events from '@dtx-company/inter-app/src/event-tracking/events/homepage'
import useTranslation from 'next-translate/useTranslation'

export interface ProUpsellBannerProps {
  sectionId?: string
}

export const ProUpsellBanner: FC<ProUpsellBannerProps> = ({ sectionId }) => {
  const { r, g, b } = useMemo(() => hexToRgb('#006d3d'), [])
  const backgroundGradient = `linear-gradient(270deg, rgba(${r}, ${g}, ${b}, 0), rgba(${r}, ${g}, ${b}, 1))`
  const { t } = useTranslation('logged-out-generator')
  return (
    <Stack
      id={sectionId}
      sx={{
        backgroundColor: 'tertiary.dark',
        pl: '80px',
        height: 'min-content'
      }}
      direction={'row'}
    >
      <Stack sx={{ maxWidth: '40%' }}>
        <Typography
          variant="headlineSmall"
          color={'onSurface.inverse'}
          style={{ marginTop: '0.25rem' }}
        >
          {t('ProUpsellBanner.title')}
        </Typography>
        <Typography
          variant="bodySmall"
          color={'onSurface.inverse'}
          style={{ marginTop: '0.25rem' }}
        >
          {t('ProUpsellBanner.description')}
        </Typography>
        <Box sx={{ my: 1 }}>
          <Button
            color={'inherit'}
            href={
              'https://www.flowcode.com/contact-sales?utm_source=Free-Generator&utm_medium=Banner&utm_campaign=Book_a_demo&utm_content=&utm_term='
            }
            onClick={() => {
              events.Flowcode_LoggedOutGenerator_Clicked_LowerBannerText({
                linkText: t('ProUpsellBanner.button')
              })
            }}
          >
            {t('ProUpsellBanner.button')}
          </Button>
        </Box>
      </Stack>

      <Box sx={{ width: '60%', borderWidth: '2px' }}>
        <Box sx={{ position: 'relative', width: '100%', minHeight: '150px' }}>
          <NextImage
            src={'/graphics/locg/flowcodes-group.png'}
            alt={'Pretty QR codes'}
            fill
            sizes="50vw"
            style={{
              borderLeft: `2px solid tertiary.dark`,
              objectFit: 'cover'
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              background: backgroundGradient,
              top: 0,
              left: 0,
              right: 0,
              bottom: 0
            }}
          />
        </Box>
      </Box>
    </Stack>
  )
}
